import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import {
    Navbar,
    Container,
    Nav,
    NavDropdown,
    Form,
    Button,
    Modal,
} from 'react-bootstrap';
import RenderOffCanvas from '../offcanvas/offcanvas';
import '../processHub/processHubNavbar/phNavbar.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { AzureLogout } from '../../containers/auth/AzureLogin';
import brandLogo from '../../assets/icons/Agilisium new logo .png';
import PeopleHubLogo from '../../assets/logo/PeopleHubWhiteLogo.png';
import { NavLink } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { MdHelpCenter } from 'react-icons/md';
import { FaHandsHelping } from 'react-icons/fa';
import { CgClose } from 'react-icons/cg';
import { getAuthProvider } from '../../containers/auth/azureAuthProvider';
import { StringEncryption } from '../../utils';
import axios from 'axios';
import api from '../../api';
import HubSpoc from '../hubspoc/HubSpoc';
import { IoClose } from 'react-icons/io5';
import { trackEvent } from '../../utils/gaTracking';

function PeopleHubNavigationbar({ hubId }) {
    const [show, setShow] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [helpText, setHelpText] = useState('');
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [menus, setMenus] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const handleOpenPdf = () => setShowModal(true);
    const handleClosePdf = () => setShowModal(false);
  
    const navigate = useNavigate();
    const helpRef = useRef(null);
    const btnRef = useRef(null);
    const authState = useSelector((state) => state.authUser);
    const role_id = authState?.profile?.role?.role_id;
    const userRoles = authState?.userRoles || [];
    const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;

    const sendMail = async (content) => {
        const accessToken = await (
            await getAuthProvider().getAccessToken()
        ).accessToken;
        const encryptToken = StringEncryption(accessToken);
        const data = {
            from: `${authState?.profile?.email}`,
            to: 'hr@agilisium.com',
            subject: 'Help center',
            desc: content,
            accesToken: encryptToken,
        };
        const url = `${process.env.REACT_APP_API_DOMAIN}/api/helpcenter/sent-email`;
        const response = await axios.post(url, data);
        if (response) {
            setHelpText('');
            setShowHelp(false);
        }
    };

    const handleClose = (dropdown) => {
        setShow(false);
        setActiveDropdown(dropdown);
    };

    const handleClickOutside = (event) => {
        if (helpRef.current && !helpRef.current.contains(event.target) && btnRef.current && !btnRef.current.contains(event.target)) {
            setShowHelp(false);
        }
    };

    // useEffect(() => {
    //     if (role_id) {
    //         fetchMenus();
    //     }
    // }, [role_id]);

const fetchMenus = async () => {
    try {
        const response = await api.rolemenu.getMenuByRoleId(role_id);
        setMenus(Array.isArray(response.data.data) ? response.data.data : []);
    } catch (error) {
        console.error("Error fetching menu:", error);
        setMenus([]);
    }
};

      
      useEffect(() => {
        document.addEventListener('mouseout', handleClickOutside);
        return () => {
          document.removeEventListener('mouseout', handleClickOutside);
        };
      }, []);
        

    return (
        <>
        {/* <Modal show={showModal} onHide={handleClosePdf} fullscreen centered>
                <div className="d-flex justify-content-between align-items-center">
                    <div> </div>
                        <div><h5>Employee Handbook</h5></div>
                        <Button variant="primary" onClick={handleClosePdf}><IoClose /></Button>
                    </div>
                <Modal.Body>
                    <iframe
                        src={`/GlobalEmployeeHandbook.pdf#view=Fit`}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                    >
                          This browser does not support PDFs. Please download the PDF to view it: <a href="/GlobalEmployeeHandbook.pdF">Download PDF</a>
                    </iframe>
                </Modal.Body>
        </Modal> */}
            <Navbar
                expand="lg"
                className="bg-body-tertiary p-0"
                expanded={show}
                style={{ position: 'fixed', width: '100%', zIndex: '999', padding: '100px !important', top: 0 }}
            >
                <Container
                    fluid
                    style={{
                        background: '#FFF',
                    }}
                    className="bg-white p-1 border border-gray-400 "
                >
                    <Navbar.Brand
                        className="brand"
                    >
                        <img
                            src={brandLogo}
                            alt="brand"
                            style={{
                                top: '19px',
                                left: '48px',
                                height: '58px',
                                opacity: '1',
                            }}
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle
                        aria-controls="navbarScroll"
                        onClick={() => setShow(!show)}
                    />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            // style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <Nav.Link
                                as={NavLink}
                                to="/peopleHub"
                                className={`px-4 navHeader ${activeDropdown === 'home' ? 'active' : ''}`}
                                onClick={() => handleClose('home')}
                            >
                                Home
                            </Nav.Link>
                            {/* <Nav.Link
                                as={NavLink}
                                to="/peopleHub"
                                className={`px-4 navHeader}`}
                                onClick={() => {
                                    handleOpenPdf();
                                    handleClose('employeeHandbook');
                                    trackEvent('view_employee_handbook', 'Employee Handbook Viewed', 'Employee Handbook Viewed', 1, user_id, user_email);
                                }
                                }
                            >
                                Employee Handbook
                            </Nav.Link> */}
                            <NavDropdown
                                title="Explore"
                                id="navbarScrollingDropdown"
                                className={`px-4 navHeader ${activeDropdown === 'explore' ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/findYourAssociates"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('explore')}
                                >
                                    Find Your Associates
                                </NavDropdown.Item>
                                <NavDropdown.Divider className='divider'/>
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/policiesAndBenefits"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('explore')}
                                >
                                    Policies and Benefits
                                </NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown
                                title="About"
                                id="navbarScrollingDropdown"
                                className={`px-4 navHeader ${activeDropdown === 'about' ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    href="https://www.agilisium.com/about-agilisium"
                                    target="_blank"
                                    className="bg-transparent menulink"
                                >
                                    Company
                                </NavDropdown.Item>
                                <NavDropdown.Divider className='divider'/>
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/clientSummary"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('about')}
                                >
                                    Clients Summary
                                </NavDropdown.Item>
                            </NavDropdown>

                            {/* <>
                                {menus.length > 0 && (
                                    <NavDropdown
                                    title={role_id === 6 ? "Super Admin" : "Admin"}
                                        id="navbarScrollingDropdown"
                                        className={`px-4 navHeader ${activeDropdown === "admin" ? "active" : ""}`}
                                    >
                                        {menus.map(menu => (
                                            <React.Fragment key={menu.id}>
                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={menu.menuDetails.route}
                                                    className="bg-transparent menulink"
                                                    onClick={() => handleClose("admin")}
                                                >
                                                    {menu.menuDetails.menu}
                                                </NavDropdown.Item>
                                                <NavDropdown.Divider className="divider" />
                                            </React.Fragment>
                                        ))}
                                    </NavDropdown>
                                )}
                            </> */}

                            {(hasRole(6) || hasRole(12)) && <NavDropdown
                                title={hasRole(6) ? "Super Admin" : "Admin"}
                                id="navbarScrollingDropdown"
                                className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/manageAnnouncements"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Announcements
                                </NavDropdown.Item>
                                {/* <NavDropdown.Divider className='divider' />
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/managPeopleHubGallery"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Happy Moments
                                </NavDropdown.Item> */}
                                <NavDropdown.Divider className='divider' />
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/manageEmployeeSpotlight"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Bravo Board
                                </NavDropdown.Item>
                                <NavDropdown.Divider className='divider' />
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/buddyreferrals"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Buddy Referrals
                                </NavDropdown.Item>
                                <NavDropdown.Divider className='divider' />
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/managePolicy"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Policies and Benefits
                                </NavDropdown.Item>
                                <NavDropdown.Divider className='divider' />
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/manageclientdetails"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Client Summary
                                </NavDropdown.Item>
                            </NavDropdown>}
                            <NavLink>
                                <HubSpoc hubId={hubId} />
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>
                    {/* <Navbar.Text
                        className="helpCenter brand px-3"
                        onClick={() => {
                            setShowHelp(true);
                        }}
                        ref={btnRef}
                        style={{
                            cursor: 'pointer',
                            padding: '2px',
                            marginRight: '50px',
                            color: '#fff',
                            border: '1px solid',
                            borderRadius: '10px',
                        }}
                    >
                        Help Center
                        <FaHandsHelping size={30} />
                    </Navbar.Text> */}
                    {showHelp && (
                        <div id="popoverContent" className="popover-content" ref={helpRef}>
                            <div className="d-flex flex-column">
                                <p>
                                    Write your troubleshooting questions to our expertise.
                                </p>
                                <textarea
                                    className='mailDescTextarea'
                                    rows="5"
                                    cols="50"
                                    maxLength="200"
                                    value={helpText}
                                    onChange={(e) =>
                                        setHelpText(e.target.value)
                                    }
                                ></textarea>
                                <div className="d-flex justify-content-end">
                                    <Button
                                        variant="btn btn-secondary"
                                        className="my-2 me-1"
                                        style={{ width: '100px' }}
                                        onClick={() => {
                                            setHelpText('');
                                            setShowHelp(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="my-2 ms-1"
                                        style={{ width: '100px' }}
                                        disabled={helpText === ''}
                                        onClick={() => sendMail(helpText)}
                                    >
                                        Send
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                    <Navbar.Brand
                        className="brand"
                        onClick={() => navigate('/')}
                    >
                        <Button className='backtohomebtn'>Go to Agilisium Page</Button>
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </>
    );
}

export default PeopleHubNavigationbar;
